import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ORIGIN,
});

export default axiosInstance;
